module.exports = __webpack_public_path__ + "static/tooltip-direct-dont-30d8408b1d14c7a19f2df5fdade3e8e9.png";